import React from "react";
import { Link } from "react-router-dom";

function Dashboard() {
  return (
    <div className="flex flex-col flex-1 overflow-y-auto">
      <div className="p-4">
        <h1 className="text-black text-xl uppercase mt-16 mx-16 text-center mb-4">
          Welcome to Tendo Docs!
        </h1>
        
        <p className="mt-2 text-gray-600 text-center">
          Navigate to different sections of the Operations Dashboard application below:
        </p>
        
        <div className="grid grid-cols-2 gap-4 mt-8">
          <Link to="/account/marketing" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            Marketing
          </Link>
          <Link to="/account/coupon" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            Coupons
          </Link>
          <Link to="/account/appsection" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            App Section
          </Link>
          <Link to="/account/producttemplate" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            Product Template
          </Link>
          <Link to="/account/reseller" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            Resellers
          </Link>
          <Link to="/account/shops" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            Shops
          </Link>
          <Link to="/account/supplier" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            Suppliers
          </Link>
          <Link to="/account/campaigns" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            Campaigns
          </Link>
          <Link to="/expressorders" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            Express Orders
          </Link>
          <Link to="/offlineorders" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            Offline Orders
          </Link>
          <Link to="/digitalorders" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            Digital Orders
          </Link>
          <Link to="/order" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            Orders
          </Link>
          <Link to="/inventory/products" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            Products
          </Link>
          <Link to="/inventory/digital-products" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            Digital Products
          </Link>
          <Link to="/inventory/discounts" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            Discounts
          </Link>
          <Link to="/inventory/categories" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            Categories
          </Link>
          <Link to="/inventory/collections" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            Collections
          </Link>
          <Link to="/location/delivery-location" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            Delivery Location
          </Link>
          <Link to="/location/pickup-location" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            Pickup Locations
          </Link>
          <Link to="/payment/forex" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            Forex Rates
          </Link>
          <Link to="/payment/payouts" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            Payout Requests
          </Link>
          <Link to="/payment/payment-transactions" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            Payment Transactions
          </Link>
          <Link to="/payment/profit-processing" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            Profit Processing
          </Link>
          <Link to="/system/config" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            System Config
          </Link>
          <Link to="/system/status" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            System Status
          </Link>
          <Link to="/hr/employees" className="p-4 bg-blue-500 text-white rounded-lg text-center shadow hover:bg-blue-600">
            Manage Employees
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
